import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

/**
 * マイページ定期便リダイレクトコンポーネント
 *
 * @element kd-mypage-subscription-redirect
 * @description Huckleberry URL（account?hbSubscriptionPath=）検知時に
 *              マイページの不要なセクションを非表示にし、定期便管理UIを表示する。
 */
@customElement('kd-mypage-subscription-redirect')
export class KdMypageSubscriptionRedirect extends LitElement {
  createRenderRoot() {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();

    if (window.location.href.indexOf('account?hbSubscriptionPath=') === -1) return;

    // 不要セクションを非表示
    const hideSelectors = [
      SELECTORS.ACCOUNT.MYPAGE_USER_STATUS,
      SELECTORS.ACCOUNT.MYPAGE_SUPPORT_REPORT,
      SELECTORS.ACCOUNT.MYPAGE_SNS_AREA,
      SELECTORS.ACCOUNT.MYPAGE_BACK_TO_TOP,
    ];

    for (const selector of hideSelectors) {
      const el = document.querySelector(selector) as HTMLElement | null;
      if (el) el.classList.add('hidden');
    }

    // 定期便リンクを挿入
    const linkContainer = document.getElementById('eccube-link-for-perioic-purchase');
    if (linkContainer) {
      linkContainer.insertAdjacentHTML(
        'afterbegin',
        '<div class="tw:mt-[-80px] tw:mx-auto tw:mb-[60px] tw:text-right tw:max-w-[700px]">' +
          '<a href="https://archive.kuradashi.jp/mypage/periodic" target="_parent">' +
          // `tw:text-sm` は使わない。@theme に --text-sm の定義が無く Tailwind 既定の
          // .875rem が残っており、本テーマの root font-size 10px（theme.css の
          // `calc(var(--font-body-scale) * 62.5%)`）と掛かって 8.75px になる。
          // px 化済みトークンの `tw:text-base`(15px) を使う（v1 の 15px と一致）。
          '<span class="tw:text-base">' +
          ' 2022年5月16日以前のプレミアム会員、 <br class="is-sp">ロスワイン定期便の確認はこちら </span>' +
          '</a></div>',
      );
    }
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-mypage-subscription-redirect': KdMypageSubscriptionRedirect;
  }
}
